// MSMEOwnerPATranslations.js

const msmeOwnerPATranslations = {
  en: {
    pendingTasks: "Pending Tasks",
    taskCompletionRatio: "Task Completion Ratio",
    rcaEntries: "RCA Entries This Month",
    sakshamRanking: "SAKSHAM MSME Ranking",
    todoDate: "Date",
    todo1Title: "Follow-up with Vendor for Raw Material",
    todo1Desc: "Pending for 3 days | Priority: High",
    todo2Title: "GST Filing Preparation",
    todo2Desc: "Due in 2 days | Finance & Compliance",
    todo3Title: "Machine Breakdown RCA Update",
    todo3Desc: "Production Floor Observation",

    operations: "Operations",
    finance: "Finance",
    production: "Production",

    reminderEnabled: "Reminder Enabled",
    whatsappAlert: "WhatsApp Alert",
    rcaLinked: "RCA Linked",
    aiReminder: "AI Reminder",
    emailNotification: "Email Notification",
    correctiveActionPending: "Corrective Action Pending",

    list: "List",
    create: "Create",
    aiInsights: "AI Insights",
    reports: "Reports",
    myRank: "My Rank",
    rewards: "Rewards",

    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",

    taskCompletionPercent: "Task Completion %",

    dailyProductivityAI: "Daily Productivity AI for MSMEs Owners",

    heroDescription:
      "AI-assisted productivity, operational discipline, reminders, RCA tracking, AI Signals, voice workflows, and MSME transformation intelligence.",

    aiStack: "AI Stack",
    aiStackValue: "LLM + RAG + Cognitive + Agents",

    voiceAI: "Voice AI",

    todoList: "To-Do List",
    todoListDesc: "AI-assisted operational workflow tracking",

    addTask: "Add Task",

    ttsEnabled: "TTS Enabled",

    createTodo: "Create New To-Do",
    createTodoDesc:
      "Voice-enabled AI-assisted task creation workflow",

    taskTitle: "Task Title",
    enterTaskTitle: "Enter task title",

    priority: "Priority",
    high: "High",
    medium: "Medium",
    low: "Low",

    taskDetails: "Task Details",

    taskDetailsPlaceholder:
      "Voice or text-based task input in vernacular language",

    startVoiceInput: "Start Voice Input",
    refineWithAI: "Refine with AI",

    voiceSupportText:
      "Supports Speech-to-Text (STT) voice input for hands-free task creation in vernacular languages.",

    productivityTrend: "Productivity Trend",
    weeklyAnalytics: "Weekly task completion analytics",

    aiInsightsSignals: "AI Insights / AI Signals",

    aiInsightsDesc:
      "Contextual operational intelligence, cognitive AI, autonomous agents, operational diagnostics and MSME risk signals.",
  },

  hi: {
    pendingTasks: "लंबित कार्य",
    taskCompletionRatio: "कार्य पूर्णता अनुपात",
    rcaEntries: "इस माह RCA प्रविष्टियाँ",
    sakshamRanking: "सक्षम MSME रैंकिंग",

    todo1Title: "कच्चे माल हेतु विक्रेता से फॉलो-अप",
    todo1Desc: "3 दिनों से लंबित | प्राथमिकता: उच्च",
    todo2Title: "GST फाइलिंग तैयारी",
    todo2Desc: "2 दिनों में देय | वित्त एवं अनुपालन",
    todo3Title: "मशीन ब्रेकडाउन RCA अपडेट",
    todo3Desc: "उत्पादन फ्लोर निरीक्षण",

    operations: "ऑपरेशन्स",
    finance: "वित्त",
    production: "उत्पादन",

    reminderEnabled: "रिमाइंडर सक्रिय",
    whatsappAlert: "व्हाट्सएप अलर्ट",
    rcaLinked: "RCA लिंक्ड",
    aiReminder: "AI रिमाइंडर",
    emailNotification: "ईमेल सूचना",
    correctiveActionPending: "सुधारात्मक कार्रवाई लंबित",

    list: "सूची",
    create: "बनाएँ",
    aiInsights: "AI अंतर्दृष्टि",
    reports: "रिपोर्ट",
    rewards: "पुरस्कार",

    mon: "सोम",
    tue: "मंगल",
    wed: "बुध",
    thu: "गुरु",
    fri: "शुक्र",
    sat: "शनि",

    taskCompletionPercent: "कार्य पूर्णता %",

    dailyProductivityAI: "MSME मालिकों हेतु दैनिक उत्पादकता AI",

    heroDescription:
      "AI-सहायित उत्पादकता, संचालन अनुशासन, रिमाइंडर, RCA ट्रैकिंग, AI संकेत, वॉइस वर्कफ़्लो और MSME परिवर्तन बुद्धिमत्ता।",

    aiStack: "AI स्टैक",
    aiStackValue: "LLM + RAG + कॉग्निटिव + एजेंट्स",

    voiceAI: "वॉइस AI",

    todoList: "कार्य सूची",
    todoListDesc: "AI-सहायित संचालन वर्कफ़्लो ट्रैकिंग",

    addTask: "कार्य जोड़ें",

    ttsEnabled: "TTS सक्रिय",

    createTodo: "नया कार्य बनाएँ",
    createTodoDesc:
      "वॉइस-सक्षम AI-सहायित कार्य निर्माण वर्कफ़्लो",

    taskTitle: "कार्य शीर्षक",
    enterTaskTitle: "कार्य शीर्षक दर्ज करें",

    priority: "प्राथमिकता",
    high: "उच्च",
    medium: "मध्यम",
    low: "निम्न",

    taskDetails: "कार्य विवरण",

    taskDetailsPlaceholder:
      "स्थानीय भाषा में वॉइस या टेक्स्ट आधारित कार्य इनपुट",

    startVoiceInput: "वॉइस इनपुट प्रारंभ करें",
    refineWithAI: "AI से परिष्कृत करें",

    voiceSupportText:
      "स्थानीय भाषाओं में हैंड्स-फ्री कार्य निर्माण हेतु Speech-to-Text (STT) समर्थन।",

    productivityTrend: "उत्पादकता प्रवृत्ति",
    weeklyAnalytics: "साप्ताहिक कार्य पूर्णता विश्लेषण",

    aiInsightsSignals: "AI अंतर्दृष्टि / AI संकेत",

    aiInsightsDesc:
      "संदर्भित संचालन बुद्धिमत्ता, कॉग्निटिव AI, स्वायत्त एजेंट्स, संचालन निदान एवं MSME जोखिम संकेत।",
  },

  mr: {
    pendingTasks: "प्रलंबित कामे",
    taskCompletionRatio: "काम पूर्णता प्रमाण",
    rcaEntries: "या महिन्यातील RCA नोंदी",
    sakshamRanking: "सक्षम MSME क्रमवारी",

    todo1Title: "कच्च्या मालासाठी विक्रेत्याशी फॉलो-अप",
    todo1Desc: "3 दिवसांपासून प्रलंबित | प्राधान्य: उच्च",
    todo2Title: "GST फाइलिंग तयारी",
    todo2Desc: "2 दिवसांत देय | वित्त आणि अनुपालन",
    todo3Title: "मशीन ब्रेकडाउन RCA अद्यतन",
    todo3Desc: "उत्पादन विभाग निरीक्षण",

    operations: "ऑपरेशन्स",
    finance: "वित्त",
    production: "उत्पादन",

    reminderEnabled: "स्मरणपत्र सक्रिय",
    whatsappAlert: "व्हॉट्सअॅप अलर्ट",
    rcaLinked: "RCA लिंक",
    aiReminder: "AI स्मरणपत्र",
    emailNotification: "ईमेल सूचना",
    correctiveActionPending: "सुधारात्मक कृती प्रलंबित",

    list: "यादी",
    create: "तयार करा",
    aiInsights: "AI अंतर्दृष्टी",
    reports: "अहवाल",
    rewards: "पुरस्कार",

    mon: "सोम",
    tue: "मंगळ",
    wed: "बुध",
    thu: "गुरु",
    fri: "शुक्र",
    sat: "शनि",

    taskCompletionPercent: "काम पूर्णता %",

    dailyProductivityAI: "MSME मालकांसाठी दैनिक उत्पादकता AI",

    heroDescription:
      "AI-सहाय्यित उत्पादकता, कार्यशिस्त, स्मरणपत्रे, RCA ट्रॅकिंग, AI संकेत, व्हॉइस वर्कफ्लो आणि MSME परिवर्तन बुद्धिमत्ता.",

    aiStack: "AI स्टॅक",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "व्हॉइस AI",

    todoList: "कार्य यादी",
    todoListDesc: "AI-सहाय्यित ऑपरेशनल वर्कफ्लो ट्रॅकिंग",

    addTask: "कार्य जोडा",

    ttsEnabled: "TTS सक्रिय",

    createTodo: "नवीन कार्य तयार करा",
    createTodoDesc:
      "व्हॉइस-सक्षम AI-सहाय्यित कार्य निर्मिती प्रक्रिया",

    taskTitle: "कार्य शीर्षक",
    enterTaskTitle: "कार्य शीर्षक प्रविष्ट करा",

    priority: "प्राधान्य",
    high: "उच्च",
    medium: "मध्यम",
    low: "कमी",

    taskDetails: "कार्य तपशील",

    taskDetailsPlaceholder:
      "स्थानिक भाषेत व्हॉइस किंवा मजकूर आधारित कार्य इनपुट",

    startVoiceInput: "व्हॉइस इनपुट सुरू करा",
    refineWithAI: "AI सह सुधारणा करा",

    voiceSupportText:
      "स्थानिक भाषांमध्ये हँड्स-फ्री कार्य निर्मितीसाठी Speech-to-Text (STT) समर्थन.",

    productivityTrend: "उत्पादकता ट्रेंड",
    weeklyAnalytics: "साप्ताहिक कार्य पूर्णता विश्लेषण",

    aiInsightsSignals: "AI अंतर्दृष्टी / AI संकेत",

    aiInsightsDesc:
      "संदर्भाधारित ऑपरेशनल बुद्धिमत्ता, Cognitive AI, स्वयंचलित एजंट्स आणि MSME जोखीम संकेत.",
  },

  gu: { 
    pendingTasks: "બાકી કાર્યો",
    taskCompletionRatio: "કાર્ય પૂર્ણતા પ્રમાણ",
    rcaEntries: "આ મહિનાની RCA એન્ટ્રીઓ",
    sakshamRanking: "સક્ષમ MSME રેન્કિંગ",

    todo1Title: "કાચા માલ માટે વેન્ડર સાથે અનુસરણ",
    todo1Desc: "3 દિવસથી બાકી | પ્રાથમિકતા: ઊંચી",
    todo2Title: "GST ફાઇલિંગ તૈયારી",
    todo2Desc: "2 દિવસમાં બાકી | નાણાં અને પાલન",
    todo3Title: "મશીન બ્રેકડાઉન RCA અપડેટ",
    todo3Desc: "ઉત્પાદન ફ્લોર નિરીક્ષણ",

    operations: "ઓપરેશન્સ",
    finance: "નાણાં",
    production: "ઉત્પાદન",

    reminderEnabled: "રીમાઇન્ડર સક્રિય",
    whatsappAlert: "વોટ્સએપ એલર્ટ",
    rcaLinked: "RCA જોડાયેલ",
    aiReminder: "AI રીમાઇન્ડર",
    emailNotification: "ઈમેલ સૂચના",
    correctiveActionPending: "સુધારાત્મક કાર્યવાહી બાકી",

    list: "યાદી",
    create: "બનાવો",
    aiInsights: "AI સમજણ",
    reports: "રિપોર્ટ્સ",
    rewards: "ઇનામો",

    mon: "સોમ",
    tue: "મંગળ",
    wed: "બુધ",
    thu: "ગુરુ",
    fri: "શુક્ર",
    sat: "શનિ",

    taskCompletionPercent: "કાર્ય પૂર્ણતા %",

    dailyProductivityAI: "MSME માલિકો માટે દૈનિક પ્રોડક્ટિવિટી AI",

    heroDescription:
        "AI આધારિત પ્રોડક્ટિવિટી, ઓપરેશનલ શિસ્ત, રીમાઇન્ડર્સ, RCA ટ્રેકિંગ, AI સિગ્નલ્સ, વોઇસ વર્કફ્લો અને MSME ટ્રાન્સફોર્મેશન ઈન્ટેલિજન્સ.",

    aiStack: "AI સ્ટેક",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "વોઇસ AI",

    todoList: "કાર્ય સૂચિ",
    todoListDesc: "AI આધારિત ઓપરેશનલ વર્કફ્લો ટ્રેકિંગ",

    addTask: "કાર્ય ઉમેરો",

    ttsEnabled: "TTS સક્રિય",

    createTodo: "નવું કાર્ય બનાવો",
    createTodoDesc:
        "વોઇસ સક્ષમ AI આધારિત કાર્ય સર્જન વર્કફ્લો",

    taskTitle: "કાર્ય શીર્ષક",
    enterTaskTitle: "કાર્ય શીર્ષક દાખલ કરો",

    priority: "પ્રાથમિકતા",
    high: "ઉચ્ચ",
    medium: "મધ્યમ",
    low: "નીચું",

    taskDetails: "કાર્ય વિગતો",

    taskDetailsPlaceholder:
        "સ્થાનિક ભાષામાં વોઇસ અથવા ટેક્સ્ટ આધારિત કાર્ય ઇનપુટ",

    startVoiceInput: "વોઇસ ઇનપુટ શરૂ કરો",
    refineWithAI: "AI સાથે સુધારો",

    voiceSupportText:
        "સ્થાનિક ભાષાઓમાં હેન્ડ્સ-ફ્રી કાર્ય સર્જન માટે Speech-to-Text (STT) આધાર.",

    productivityTrend: "ઉત્પાદકતા પ્રવાહ",
    weeklyAnalytics: "સાપ્તાહિક કાર્ય પૂર્ણતા વિશ્લેષણ",

    aiInsightsSignals: "AI ઇન્સાઇટ્સ / AI સિગ્નલ્સ",

    aiInsightsDesc:
        "સંદર્ભ આધારિત ઓપરેશનલ ઇન્ટેલિજન્સ, Cognitive AI, સ્વાયત્ત એજન્ટ્સ, ઓપરેશનલ ડાયગ્નોસ્ટિક્સ અને MSME જોખમ સિગ્નલ્સ.",
  },

  bn: {
    pendingTasks: "মুলতুবি কাজ",
    taskCompletionRatio: "কাজ সম্পন্ন অনুপাত",
    rcaEntries: "এই মাসের RCA এন্ট্রি",
    sakshamRanking: "সক্ষম MSME র‌্যাঙ্কিং",

    todo1Title: "কাঁচামালের জন্য বিক্রেতার সাথে ফলো-আপ",
    todo1Desc: "৩ দিন ধরে মুলতুবি | অগ্রাধিকার: উচ্চ",
    todo2Title: "GST ফাইলিং প্রস্তুতি",
    todo2Desc: "২ দিনের মধ্যে জমা | ফাইন্যান্স ও কমপ্লায়েন্স",
    todo3Title: "মেশিন ব্রেকডাউন RCA আপডেট",
    todo3Desc: "প্রোডাকশন ফ্লোর পর্যবেক্ষণ",

    operations: "অপারেশনস",
    finance: "ফাইন্যান্স",
    production: "উৎপাদন",

    reminderEnabled: "রিমাইন্ডার সক্রিয়",
    whatsappAlert: "হোয়াটসঅ্যাপ অ্যালার্ট",
    rcaLinked: "RCA সংযুক্ত",
    aiReminder: "AI রিমাইন্ডার",
    emailNotification: "ইমেইল নোটিফিকেশন",
    correctiveActionPending: "সংশোধনী ব্যবস্থা মুলতুবি",

    list: "তালিকা",
    create: "তৈরি করুন",
    aiInsights: "AI অন্তর্দৃষ্টি",
    reports: "রিপোর্ট",
    rewards: "পুরস্কার",

    mon: "সোম",
    tue: "মঙ্গল",
    wed: "বুধ",
    thu: "বৃহস্পতি",
    fri: "শুক্র",
    sat: "শনি",

    taskCompletionPercent: "কাজ সম্পন্ন %",

    dailyProductivityAI: "MSME মালিকদের জন্য দৈনিক প্রোডাক্টিভিটি AI",

    heroDescription:
        "AI-সহায়ক প্রোডাক্টিভিটি, অপারেশনাল শৃঙ্খলা, রিমাইন্ডার, RCA ট্র্যাকিং, AI সিগন্যাল, ভয়েস ওয়ার্কফ্লো এবং MSME ট্রান্সফরমেশন ইন্টেলিজেন্স।",

    aiStack: "AI স্ট্যাক",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "ভয়েস AI",

    todoList: "কাজের তালিকা",
    todoListDesc: "AI-সহায়ক অপারেশনাল ওয়ার্কফ্লো ট্র্যাকিং",

    addTask: "কাজ যোগ করুন",

    ttsEnabled: "TTS সক্রিয়",

    createTodo: "নতুন কাজ তৈরি করুন",
    createTodoDesc:
        "ভয়েস-সক্ষম AI-সহায়ক কাজ তৈরির ওয়ার্কফ্লো",

    taskTitle: "কাজের শিরোনাম",
    enterTaskTitle: "কাজের শিরোনাম লিখুন",

    priority: "অগ্রাধিকার",
    high: "উচ্চ",
    medium: "মাঝারি",
    low: "নিম্ন",

    taskDetails: "কাজের বিবরণ",

    taskDetailsPlaceholder:
        "স্থানীয় ভাষায় ভয়েস বা টেক্সট ভিত্তিক কাজ ইনপুট",

    startVoiceInput: "ভয়েস ইনপুট শুরু করুন",
    refineWithAI: "AI দিয়ে উন্নত করুন",

    voiceSupportText:
        "স্থানীয় ভাষায় হ্যান্ডস-ফ্রি কাজ তৈরির জন্য Speech-to-Text (STT) সমর্থন।",

    productivityTrend: "উৎপাদনশীলতার প্রবণতা",
    weeklyAnalytics: "সাপ্তাহিক কাজ সম্পন্ন বিশ্লেষণ",

    aiInsightsSignals: "AI ইনসাইটস / AI সিগন্যাল",

    aiInsightsDesc:
        "প্রাসঙ্গিক অপারেশনাল ইন্টেলিজেন্স, Cognitive AI, স্বয়ংক্রিয় এজেন্ট, অপারেশনাল ডায়াগনস্টিকস এবং MSME ঝুঁকি সিগন্যাল।",
  },

  ta: {
    pendingTasks: "நிலுவையில் உள்ள பணிகள்",
    taskCompletionRatio: "பணி நிறைவு விகிதம்",
    rcaEntries: "இந்த மாத RCA பதிவுகள்",
    sakshamRanking: "சக்ஷம் MSME தரவரிசை",

    todo1Title: "மூலப்பொருள் விற்பனையாளரை தொடர்புகொள்",
    todo1Desc: "3 நாட்களாக நிலுவையில் | முன்னுரிமை: உயர்ந்தது",
    todo2Title: "GST தாக்கல் தயாரிப்பு",
    todo2Desc: "2 நாட்களில் கடைசி தேதி | நிதி & இணக்கம்",
    todo3Title: "இயந்திர கோளாறு RCA புதுப்பிப்பு",
    todo3Desc: "உற்பத்தி தளம் கண்காணிப்பு",

    operations: "செயல்பாடுகள்",
    finance: "நிதி",
    production: "உற்பத்தி",

    reminderEnabled: "நினைவூட்டல் செயல்படுத்தப்பட்டது",
    whatsappAlert: "வாட்ஸ்அப் எச்சரிக்கை",
    rcaLinked: "RCA இணைக்கப்பட்டது",
    aiReminder: "AI நினைவூட்டல்",
    emailNotification: "மின்னஞ்சல் அறிவிப்பு",
    correctiveActionPending: "திருத்த நடவடிக்கை நிலுவையில்",

    list: "பட்டியல்",
    create: "உருவாக்கு",
    aiInsights: "AI பார்வைகள்",
    reports: "அறிக்கைகள்",
    rewards: "வெகுமதிகள்",

    mon: "திங்",
    tue: "செவ்",
    wed: "புத",
    thu: "வியா",
    fri: "வெள்",
    sat: "சனி",

    taskCompletionPercent: "பணி நிறைவு %",

    dailyProductivityAI: "MSME உரிமையாளர்களுக்கான தினசரி உற்பத்தித்திறன் AI",

    heroDescription:
        "AI உதவியுள்ள உற்பத்தித்திறன், செயல்பாட்டு ஒழுங்கு, நினைவூட்டல்கள், RCA கண்காணிப்பு, AI சிக்னல்கள், குரல் செயல்முறை மற்றும் MSME மாற்ற நுண்ணறிவு.",

    aiStack: "AI ஸ்டாக்",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "குரல் AI",

    todoList: "செய்ய வேண்டிய பட்டியல்",
    todoListDesc: "AI உதவியுள்ள செயல்பாட்டு பணிச்சூழல் கண்காணிப்பு",

    addTask: "பணியைச் சேர்க்கவும்",

    ttsEnabled: "TTS செயல்படுத்தப்பட்டது",

    createTodo: "புதிய பணியை உருவாக்கு",
    createTodoDesc:
        "குரல் ஆதரவு கொண்ட AI உதவியுள்ள பணி உருவாக்கம்",

    taskTitle: "பணி தலைப்பு",
    enterTaskTitle: "பணி தலைப்பை உள்ளிடவும்",

    priority: "முன்னுரிமை",
    high: "உயர்",
    medium: "நடுத்தரம்",
    low: "குறைவு",

    taskDetails: "பணி விவரங்கள்",

    taskDetailsPlaceholder:
        "உள்ளூர் மொழியில் குரல் அல்லது உரை அடிப்படையிலான பணி உள்ளீடு",

    startVoiceInput: "குரல் உள்ளீட்டை தொடங்கு",
    refineWithAI: "AI மூலம் மேம்படுத்து",

    voiceSupportText:
        "உள்ளூர் மொழிகளில் ஹேண்ட்ஸ்-ஃப்ரீ பணி உருவாக்கத்திற்கான Speech-to-Text (STT) ஆதரவு।",

    productivityTrend: "உற்பத்தித்திறன் போக்கு",
    weeklyAnalytics: "வாராந்திர பணி நிறைவு பகுப்பாய்வு",

    aiInsightsSignals: "AI பார்வைகள் / AI சிக்னல்கள்",

    aiInsightsDesc:
        "சூழல் சார்ந்த செயல்பாட்டு நுண்ணறிவு, Cognitive AI, தன்னாட்சி முகவர்கள், செயல்பாட்டு கண்டறிதல் மற்றும் MSME அபாய சிக்னல்கள்।",
  },

  te: {
    pendingTasks: "పెండింగ్ పనులు",
    taskCompletionRatio: "పని పూర్తి నిష్పత్తి",
    rcaEntries: "ఈ నెల RCA నమోదు",
    sakshamRanking: "సక్షమ్ MSME ర్యాంకింగ్",

    todo1Title: "ముడి సరుకు కోసం విక్రేతను ఫాలోఅప్ చేయండి",
    todo1Desc: "3 రోజులుగా పెండింగ్ | ప్రాధాన్యత: అధికం",
    todo2Title: "GST ఫైలింగ్ సిద్ధత",
    todo2Desc: "2 రోజుల్లో గడువు | ఫైనాన్స్ & కంప్లయన్స్",
    todo3Title: "మెషిన్ బ్రేక్‌డౌన్ RCA అప్డేట్",
    todo3Desc: "ఉత్పత్తి విభాగ పరిశీలన",

    operations: "ఆపరేషన్స్",
    finance: "ఫైనాన్స్",
    production: "ఉత్పత్తి",

    reminderEnabled: "రిమైండర్ ప్రారంభించబడింది",
    whatsappAlert: "వాట్సాప్ అలర్ట్",
    rcaLinked: "RCA లింక్ చేయబడింది",
    aiReminder: "AI రిమైండర్",
    emailNotification: "ఇమెయిల్ నోటిఫికేషన్",
    correctiveActionPending: "సరిదిద్దే చర్య పెండింగ్‌లో ఉంది",

    list: "జాబితా",
    create: "సృష్టించు",
    aiInsights: "AI అవగాహనలు",
    reports: "నివేదికలు",
    rewards: "బహుమతులు",

    mon: "సోమ",
    tue: "మంగళ",
    wed: "బుధ",
    thu: "గురు",
    fri: "శుక్ర",
    sat: "శని",

    taskCompletionPercent: "పని పూర్తి %",

    dailyProductivityAI: "MSME యజమానుల కోసం రోజువారీ ఉత్పాదకత AI",

    heroDescription:
        "AI ఆధారిత ఉత్పాదకత, ఆపరేషనల్ క్రమశిక్షణ, రిమైండర్లు, RCA ట్రాకింగ్, AI సంకేతాలు, వాయిస్ వర్క్‌ఫ్లోలు మరియు MSME మార్పు ఇంటెలిజెన్స్।",

    aiStack: "AI స్టాక్",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "వాయిస్ AI",

    todoList: "చేయవలసిన పనుల జాబితా",
    todoListDesc: "AI ఆధారిత ఆపరేషనల్ వర్క్‌ఫ్లో ట్రాకింగ్",

    addTask: "పని జోడించండి",

    ttsEnabled: "TTS ప్రారంభించబడింది",

    createTodo: "కొత్త పని సృష్టించండి",
    createTodoDesc:
        "వాయిస్ ఆధారిత AI సహాయక పని సృష్టి వర్క్‌ఫ్లో",

    taskTitle: "పని శీర్షిక",
    enterTaskTitle: "పని శీర్షికను నమోదు చేయండి",

    priority: "ప్రాధాన్యత",
    high: "అధికం",
    medium: "మధ్యస్థం",
    low: "తక్కువ",

    taskDetails: "పని వివరాలు",

    taskDetailsPlaceholder:
        "స్థానిక భాషలో వాయిస్ లేదా టెక్స్ట్ ఆధారిత పని ఇన్‌పుట్",

    startVoiceInput: "వాయిస్ ఇన్‌పుట్ ప్రారంభించండి",
    refineWithAI: "AI తో మెరుగుపరచండి",

    voiceSupportText:
        "స్థానిక భాషలలో హ్యాండ్స్-ఫ్రీ పని సృష్టి కోసం Speech-to-Text (STT) మద్దతు।",

    productivityTrend: "ఉత్పాదకత ధోరణి",
    weeklyAnalytics: "వారపు పని పూర్తి విశ్లేషణ",

    aiInsightsSignals: "AI ఇన్‌సైట్స్ / AI సంకేతాలు",

    aiInsightsDesc:
        "సందర్భాత్మక ఆపరేషనల్ ఇంటెలిజెన్స్, Cognitive AI, స్వయంచాలక ఏజెంట్లు, ఆపరేషనల్ డయాగ్నోస్టిక్స్ మరియు MSME రిస్క్ సంకేతాలు।",
  },

  kn: {
    pendingTasks: "ಬಾಕಿ ಕೆಲಸಗಳು",
    taskCompletionRatio: "ಕಾರ್ಯ ಪೂರ್ಣತಾ ಪ್ರಮಾಣ",
    rcaEntries: "ಈ ತಿಂಗಳ RCA ನಮೂದುಗಳು",
    sakshamRanking: "ಸಕ್ಷಮ್ MSME ಶ್ರೇಯಾಂಕ",

    todo1Title: "ಮೂಲ ವಸ್ತುಗಳಿಗಾಗಿ ಮಾರಾಟಗಾರರನ್ನು ಅನುಸರಿಸಿ",
    todo1Desc: "3 ದಿನಗಳಿಂದ ಬಾಕಿ | ಆದ್ಯತೆ: ಹೆಚ್ಚು",
    todo2Title: "GST ಫೈಲಿಂಗ್ ತಯಾರಿ",
    todo2Desc: "2 ದಿನಗಳಲ್ಲಿ ಕೊನೆಯ ದಿನಾಂಕ | ಹಣಕಾಸು ಮತ್ತು ಅನುಸರಣೆ",
    todo3Title: "ಯಂತ್ರ ದೋಷ RCA ನವೀಕರಣ",
    todo3Desc: "ಉತ್ಪಾದನಾ ಘಟಕ ವೀಕ್ಷಣೆ",

    operations: "ಆಪರೇಷನ್ಸ್",
    finance: "ಹಣಕಾಸು",
    production: "ಉತ್ಪಾದನೆ",

    reminderEnabled: "ಜ್ಞಾಪನೆ ಸಕ್ರಿಯಗೊಂಡಿದೆ",
    whatsappAlert: "ವಾಟ್ಸಾಪ್ ಅಲರ್ಟ್",
    rcaLinked: "RCA ಲಿಂಕ್ ಮಾಡಲಾಗಿದೆ",
    aiReminder: "AI ಜ್ಞಾಪನೆ",
    emailNotification: "ಇಮೇಲ್ ಅಧಿಸೂಚನೆ",
    correctiveActionPending: "ತಿದ್ದುಪಡಿ ಕ್ರಮ ಬಾಕಿಯಿದೆ",

    list: "ಪಟ್ಟಿ",
    create: "ರಚಿಸಿ",
    aiInsights: "AI ಒಳನೋಟಗಳು",
    reports: "ವರದಿಗಳು",
    rewards: "ಬಹುಮಾನಗಳು",

    mon: "ಸೋಮ",
    tue: "ಮಂಗಳ",
    wed: "ಬುಧ",
    thu: "ಗುರು",
    fri: "ಶುಕ್ರ",
    sat: "ಶನಿ",

    taskCompletionPercent: "ಕಾರ್ಯ ಪೂರ್ಣತೆ %",

    dailyProductivityAI: "MSME ಮಾಲೀಕರಿಗಾಗಿ ದೈನಂದಿನ ಉತ್ಪಾದಕತೆ AI",

    heroDescription:
        "AI ಸಹಾಯಕ ಉತ್ಪಾದಕತೆ, ಕಾರ್ಯಾಚರಣಾ ಶಿಸ್ತು, ಜ್ಞಾಪನೆಗಳು, RCA ಟ್ರ್ಯಾಕಿಂಗ್, AI ಸಂಕೇತಗಳು, ಧ್ವನಿ ಕಾರ್ಯಪ್ರವಾಹಗಳು ಮತ್ತು MSME ಪರಿವರ್ತನಾ ಬುದ್ಧಿಮತ್ತೆ।",

    aiStack: "AI ಸ್ಟ್ಯಾಕ್",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "ವಾಯ್ಸ್ AI",

    todoList: "ಮಾಡಬೇಕಾದ ಕಾರ್ಯಗಳ ಪಟ್ಟಿ",
    todoListDesc: "AI ಸಹಾಯಕ ಕಾರ್ಯಾಚರಣಾ ಕಾರ್ಯಪ್ರವಾಹ ಟ್ರ್ಯಾಕಿಂಗ್",

    addTask: "ಕಾರ್ಯ ಸೇರಿಸಿ",

    ttsEnabled: "TTS ಸಕ್ರಿಯಗೊಂಡಿದೆ",

    createTodo: "ಹೊಸ ಕಾರ್ಯ ರಚಿಸಿ",
    createTodoDesc:
        "ಧ್ವನಿ ಆಧಾರಿತ AI ಸಹಾಯಕ ಕಾರ್ಯ ರಚನೆ ಕಾರ್ಯಪ್ರವಾಹ",

    taskTitle: "ಕಾರ್ಯ ಶೀರ್ಷಿಕೆ",
    enterTaskTitle: "ಕಾರ್ಯ ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ",

    priority: "ಆದ್ಯತೆ",
    high: "ಹೆಚ್ಚು",
    medium: "ಮಧ್ಯಮ",
    low: "ಕಡಿಮೆ",

    taskDetails: "ಕಾರ್ಯ ವಿವರಗಳು",

    taskDetailsPlaceholder:
        "ಸ್ಥಳೀಯ ಭಾಷೆಯಲ್ಲಿ ಧ್ವನಿ ಅಥವಾ ಪಠ್ಯ ಆಧಾರಿತ ಕಾರ್ಯ ಇನ್‌ಪುಟ್",

    startVoiceInput: "ಧ್ವನಿ ಇನ್‌ಪುಟ್ ಪ್ರಾರಂಭಿಸಿ",
    refineWithAI: "AI ಮೂಲಕ ಸುಧಾರಿಸಿ",

    voiceSupportText:
        "ಸ್ಥಳೀಯ ಭಾಷೆಗಳಲ್ಲಿ ಹ್ಯಾಂಡ್ಸ್-ಫ್ರೀ ಕಾರ್ಯ ರಚನೆಗಾಗಿ Speech-to-Text (STT) ಬೆಂಬಲ।",

    productivityTrend: "ಉತ್ಪಾದಕತೆ ಪ್ರವೃತ್ತಿ",
    weeklyAnalytics: "ವಾರದ ಕಾರ್ಯ ಪೂರ್ಣತೆ ವಿಶ್ಲೇಷಣೆ",

    aiInsightsSignals: "AI ಒಳನೋಟಗಳು / AI ಸಂಕೇತಗಳು",

    aiInsightsDesc:
        "ಸಂದರ್ಭಾತ್ಮಕ ಕಾರ್ಯಾಚರಣಾ ಬುದ್ಧಿಮತ್ತೆ, Cognitive AI, ಸ್ವಯಂಚಾಲಿತ ಏಜೆಂಟ್‌ಗಳು, ಕಾರ್ಯಾಚರಣಾ ಡಯಾಗ್ನೋಸ್ಟಿಕ್ಸ್ ಮತ್ತು MSME ಅಪಾಯ ಸಂಕೇತಗಳು।",
  },

  ml: {
    pendingTasks: "ബാക്കി ജോലികൾ",
    taskCompletionRatio: "ജോലി പൂർത്തീകരണ അനുപാതം",
    rcaEntries: "ഈ മാസത്തെ RCA എൻട്രികൾ",
    sakshamRanking: "സക്ഷം MSME റാങ്കിംഗ്",

    todo1Title: "അസംസ്കൃത വസ്തുക്കൾക്കായി വിതരണക്കാരനെ ഫോളോ-അപ്പ് ചെയ്യുക",
    todo1Desc: "3 ദിവസമായി ബാക്കി | മുൻഗണന: ഉയർന്നത്",
    todo2Title: "GST ഫയലിംഗ് തയ്യാറെടുപ്പ്",
    todo2Desc: "2 ദിവസത്തിനകം അവസാന തീയതി | ധനകാര്യം & അനുസരണം",
    todo3Title: "മെഷീൻ തകരാർ RCA അപ്ഡേറ്റ്",
    todo3Desc: "ഉൽപ്പാദന നില നിരീക്ഷണം",

    operations: "ഓപ്പറേഷൻസ്",
    finance: "ധനകാര്യം",
    production: "ഉൽപ്പാദനം",

    reminderEnabled: "റിമൈൻഡർ സജീവമാക്കി",
    whatsappAlert: "വാട്സ്ആപ്പ് അലർട്ട്",
    rcaLinked: "RCA ലിങ്ക് ചെയ്തു",
    aiReminder: "AI റിമൈൻഡർ",
    emailNotification: "ഇമെയിൽ അറിയിപ്പ്",
    correctiveActionPending: "തിരുത്തൽ നടപടി ബാക്കി",

    list: "പട്ടിക",
    create: "സൃഷ്ടിക്കുക",
    aiInsights: "AI ഉൾക്കാഴ്ചകൾ",
    reports: "റിപ്പോർട്ടുകൾ",
    rewards: "പ്രതിഫലങ്ങൾ",

    mon: "തി",
    tue: "ചൊ",
    wed: "ബു",
    thu: "വ്യാ",
    fri: "വെ",
    sat: "ശ",

    taskCompletionPercent: "ജോലി പൂർത്തീകരണം %",

    dailyProductivityAI: "MSME ഉടമകൾക്കായുള്ള ദൈനംദിന ഉൽപ്പാദനക്ഷമത AI",

    heroDescription:
        "AI സഹായത്തോടെ ഉൽപ്പാദനക്ഷമത, പ്രവർത്തന ശാസ്ത്രീയം, റിമൈൻഡറുകൾ, RCA ട്രാക്കിംഗ്, AI സിഗ്നലുകൾ, വോയ്സ് വർക്ക്‌ഫ്ലോകൾ, MSME ട്രാൻസ്ഫോർമേഷൻ ഇന്റലിജൻസ്।",

    aiStack: "AI സ്റ്റാക്ക്",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "വോയ്സ് AI",

    todoList: "ചെയ്യേണ്ട ജോലികളുടെ പട്ടിക",
    todoListDesc: "AI സഹായത്തോടെ പ്രവർത്തന വർക്ക്‌ഫ്ലോ ട്രാക്കിംഗ്",

    addTask: "ജോലി ചേർക്കുക",

    ttsEnabled: "TTS സജീവമാക്കി",

    createTodo: "പുതിയ ജോലി സൃഷ്ടിക്കുക",
    createTodoDesc:
        "വോയ്സ് പിന്തുണയുള്ള AI സഹായത്തോടെ ജോലി സൃഷ്ടിക്കൽ വർക്ക്‌ഫ്ലോ",

    taskTitle: "ജോലിയുടെ ശീർഷകം",
    enterTaskTitle: "ജോലിയുടെ ശീർഷകം നൽകുക",

    priority: "മുൻഗണന",
    high: "ഉയർന്നത്",
    medium: "ഇടത്തരം",
    low: "കുറഞ്ഞത്",

    taskDetails: "ജോലി വിശദാംശങ്ങൾ",

    taskDetailsPlaceholder:
        "പ്രാദേശിക ഭാഷയിൽ വോയ്സ് അല്ലെങ്കിൽ ടെക്സ്റ്റ് അടിസ്ഥാനത്തിലുള്ള ജോലി ഇൻപുട്ട്",

    startVoiceInput: "വോയ്സ് ഇൻപുട്ട് ആരംഭിക്കുക",
    refineWithAI: "AI ഉപയോഗിച്ച് മെച്ചപ്പെടുത്തുക",

    voiceSupportText:
        "പ്രാദേശിക ഭാഷകളിൽ ഹാൻഡ്സ്-ഫ്രീ ജോലി സൃഷ്ടിക്കാനായി Speech-to-Text (STT) പിന്തുണ।",

    productivityTrend: "ഉൽപ്പാദനക്ഷമത പ്രവണതി",
    weeklyAnalytics: "ആഴ്ച്ചയിലെ ജോലി പൂർത്തീകരണ വിശകലനം",

    aiInsightsSignals: "AI ഉൾക്കാഴ്ചകൾ / AI സിഗ്നലുകൾ",

    aiInsightsDesc:
        "സന്ദർഭപരമായ പ്രവർത്തന ഇന്റലിജൻസ്, Cognitive AI, സ്വയംപ്രവർത്തക ഏജന്റുകൾ, പ്രവർത്തന ഡയഗ്നോസ്റ്റിക്സ്, MSME അപകടസൂചനകൾ।",
  },

  pa: {
    pendingTasks: "ਬਾਕੀ ਕੰਮ",
    taskCompletionRatio: "ਕੰਮ ਪੂਰਾ ਹੋਣ ਦਾ ਅਨੁਪਾਤ",
    rcaEntries: "ਇਸ ਮਹੀਨੇ ਦੀਆਂ RCA ਐਂਟਰੀਆਂ",
    sakshamRanking: "ਸਕਸ਼ਮ MSME ਰੈਂਕਿੰਗ",

    todo1Title: "ਕੱਚੇ ਮਾਲ ਲਈ ਵੇਂਡਰ ਨਾਲ ਫਾਲੋ-ਅੱਪ ਕਰੋ",
    todo1Desc: "3 ਦਿਨਾਂ ਤੋਂ ਬਾਕੀ | ਤਰਜੀਹ: ਉੱਚ",
    todo2Title: "GST ਫਾਈਲਿੰਗ ਤਿਆਰੀ",
    todo2Desc: "2 ਦਿਨਾਂ ਵਿੱਚ ਮਿਆਦ | ਵਿੱਤ ਅਤੇ ਅਨੁਕੂਲਤਾ",
    todo3Title: "ਮਸ਼ੀਨ ਖਰਾਬੀ RCA ਅਪਡੇਟ",
    todo3Desc: "ਉਤਪਾਦਨ ਫਲੋਰ ਨਿਰੀਖਣ",

    operations: "ਓਪਰੇਸ਼ਨ",
    finance: "ਵਿੱਤ",
    production: "ਉਤਪਾਦਨ",

    reminderEnabled: "ਰੀਮਾਈਂਡਰ ਚਾਲੂ",
    whatsappAlert: "ਵਟਸਐਪ ਅਲਰਟ",
    rcaLinked: "RCA ਲਿੰਕ ਕੀਤਾ ਗਿਆ",
    aiReminder: "AI ਰੀਮਾਈਂਡਰ",
    emailNotification: "ਈਮੇਲ ਸੂਚਨਾ",
    correctiveActionPending: "ਸੁਧਾਰਾਤਮਕ ਕਾਰਵਾਈ ਬਾਕੀ",

    list: "ਸੂਚੀ",
    create: "ਬਣਾਓ",
    aiInsights: "AI ਅੰਦਰੂਨੀ ਜਾਣਕਾਰੀਆਂ",
    reports: "ਰਿਪੋਰਟਾਂ",
    rewards: "ਇਨਾਮ",

    mon: "ਸੋਮ",
    tue: "ਮੰਗਲ",
    wed: "ਬੁੱਧ",
    thu: "ਵੀਰ",
    fri: "ਸ਼ੁੱਕਰ",
    sat: "ਸ਼ਨੀ",

    taskCompletionPercent: "ਕੰਮ ਪੂਰਾ %",

    dailyProductivityAI: "MSME ਮਾਲਕਾਂ ਲਈ ਰੋਜ਼ਾਨਾ ਉਤਪਾਦਕਤਾ AI",

    heroDescription:
        "AI ਸਹਾਇਤਾ ਵਾਲੀ ਉਤਪਾਦਕਤਾ, ਓਪਰੇਸ਼ਨਲ ਅਨੁਸ਼ਾਸਨ, ਰੀਮਾਈਂਡਰ, RCA ਟ੍ਰੈਕਿੰਗ, AI ਸੰਕੇਤ, ਵੋਇਸ ਵਰਕਫਲੋ ਅਤੇ MSME ਰੂਪਾਂਤਰਨ ਬੁੱਧਿਮਤਾ।",

    aiStack: "AI ਸਟੈਕ",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "ਵੋਇਸ AI",

    todoList: "ਕਰਨ ਵਾਲੇ ਕੰਮਾਂ ਦੀ ਸੂਚੀ",
    todoListDesc: "AI ਸਹਾਇਤਾ ਵਾਲੀ ਓਪਰੇਸ਼ਨਲ ਵਰਕਫਲੋ ਟ੍ਰੈਕਿੰਗ",

    addTask: "ਕੰਮ ਸ਼ਾਮਲ ਕਰੋ",

    ttsEnabled: "TTS ਚਾਲੂ",

    createTodo: "ਨਵਾਂ ਕੰਮ ਬਣਾਓ",
    createTodoDesc:
        "ਵੋਇਸ ਸਮਰਥਿਤ AI ਸਹਾਇਤਾ ਵਾਲਾ ਕੰਮ ਬਣਾਉਣ ਵਰਕਫਲੋ",

    taskTitle: "ਕੰਮ ਦਾ ਸਿਰਲੇਖ",
    enterTaskTitle: "ਕੰਮ ਦਾ ਸਿਰਲੇਖ ਦਰਜ ਕਰੋ",

    priority: "ਤਰਜੀਹ",
    high: "ਉੱਚ",
    medium: "ਦਰਮਿਆਨਾ",
    low: "ਘੱਟ",

    taskDetails: "ਕੰਮ ਦੇ ਵੇਰਵੇ",

    taskDetailsPlaceholder:
        "ਸਥਾਨਕ ਭਾਸ਼ਾ ਵਿੱਚ ਵੋਇਸ ਜਾਂ ਟੈਕਸਟ ਅਧਾਰਿਤ ਕੰਮ ਇਨਪੁੱਟ",

    startVoiceInput: "ਵੋਇਸ ਇਨਪੁੱਟ ਸ਼ੁਰੂ ਕਰੋ",
    refineWithAI: "AI ਨਾਲ ਸੁਧਾਰੋ",

    voiceSupportText:
        "ਸਥਾਨਕ ਭਾਸ਼ਾਵਾਂ ਵਿੱਚ ਹੱਥ-ਮੁਕਤ ਕੰਮ ਬਣਾਉਣ ਲਈ Speech-to-Text (STT) ਸਮਰਥਨ।",

    productivityTrend: "ਉਤਪਾਦਕਤਾ ਰੁਝਾਨ",
    weeklyAnalytics: "ਹਫਤਾਵਾਰੀ ਕੰਮ ਪੂਰਾ ਵਿਸ਼ਲੇਸ਼ਣ",

    aiInsightsSignals: "AI ਇਨਸਾਈਟਸ / AI ਸੰਕੇਤ",

    aiInsightsDesc:
        "ਸੰਦਰਭਾਤਮਕ ਓਪਰੇਸ਼ਨਲ ਇੰਟੈਲੀਜੈਂਸ, Cognitive AI, ਸਵੈਚਾਲਿਤ ਏਜੰਟ, ਓਪਰੇਸ਼ਨਲ ਡਾਇਗਨੋਸਟਿਕਸ ਅਤੇ MSME ਜੋਖਿਮ ਸੰਕੇਤ।",
  },

  as: {
    pendingTasks: "অমীমাংসিত কামসমূহ",
    taskCompletionRatio: "কাম সম্পূৰ্ণ অনুপাত",
    rcaEntries: "এই মাহৰ RCA এণ্ট্ৰিসমূহ",
    sakshamRanking: "সক্ষম MSME ৰেংকিং",

    todo1Title: "কেঁচা সামগ্ৰীৰ বাবে বিক্ৰেতাৰ সৈতে অনুসৰণ কৰক",
    todo1Desc: "৩ দিন ধৰি বাকী | অগ্ৰাধিকাৰ: উচ্চ",
    todo2Title: "GST ফাইলিং প্ৰস্তুতি",
    todo2Desc: "২ দিনৰ ভিতৰত শেষ তাৰিখ | বিত্ত আৰু অনুগত্য",
    todo3Title: "মেচিন বিকল RCA আপডেট",
    todo3Desc: "উৎপাদন ফ্ল’ৰ পৰ্যবেক্ষণ",

    operations: "অপাৰেশ্যন",
    finance: "বিত্ত",
    production: "উৎপাদন",

    reminderEnabled: "স্মাৰক সক্ৰিয়",
    whatsappAlert: "হোৱাটছএপ সতর্কতা",
    rcaLinked: "RCA সংযুক্ত",
    aiReminder: "AI স্মাৰক",
    emailNotification: "ইমেইল জাননী",
    correctiveActionPending: "সংশোধনী ব্যৱস্থা বাকী",

    list: "তালিকা",
    create: "সৃষ্টি কৰক",
    aiInsights: "AI অন্তৰ্দৃষ্টি",
    reports: "ৰিপৰ্টসমূহ",
    rewards: "পুৰস্কাৰ",

    mon: "সোম",
    tue: "মঙ্গল",
    wed: "বুধ",
    thu: "বৃহস্পতি",
    fri: "শুক্ৰ",
    sat: "শনি",

    taskCompletionPercent: "কাম সম্পূৰ্ণ %",

    dailyProductivityAI: "MSME মালিকসকলৰ বাবে দৈনিক উৎপাদনশীলতা AI",

    heroDescription:
        "AI সহায়িত উৎপাদনশীলতা, অপাৰেশ্যন শৃংখলা, স্মাৰক, RCA ট্ৰেকিং, AI সংকেত, ভয়েচ ৱৰ্কফ্লো আৰু MSME ৰূপান্তৰ বুদ্ধিমত্তা।",

    aiStack: "AI ষ্টেক",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "ভয়েচ AI",

    todoList: "কৰণীয় কামৰ তালিকা",
    todoListDesc: "AI সহায়িত অপাৰেশ্যনেল ৱৰ্কফ্লো ট্ৰেকিং",

    addTask: "কাম যোগ কৰক",

    ttsEnabled: "TTS সক্ৰিয়",

    createTodo: "নতুন কাম সৃষ্টি কৰক",
    createTodoDesc:
        "ভয়েচ-সক্ষম AI সহায়িত কাম সৃষ্টি ৱৰ্কফ্লো",

    taskTitle: "কামৰ শিৰোনাম",
    enterTaskTitle: "কামৰ শিৰোনাম লিখক",

    priority: "অগ্ৰাধিকাৰ",
    high: "উচ্চ",
    medium: "মধ্যম",
    low: "নিম্ন",

    taskDetails: "কামৰ বিৱৰণ",

    taskDetailsPlaceholder:
        "স্থানীয় ভাষাত ভয়েচ বা টেক্সট-ভিত্তিক কাম ইনপুট",

    startVoiceInput: "ভয়েচ ইনপুট আৰম্ভ কৰক",
    refineWithAI: "AI সহ উন্নত কৰক",

    voiceSupportText:
        "স্থানীয় ভাষাসমূহত হেণ্ডছ-ফ্ৰী কাম সৃষ্টিৰ বাবে Speech-to-Text (STT) সমৰ্থন।",

    productivityTrend: "উৎপাদনশীলতাৰ ধাৰা",
    weeklyAnalytics: "সাপ্তাহিক কাম সম্পূৰ্ণ বিশ্লেষণ",

    aiInsightsSignals: "AI অন্তৰ্দৃষ্টি / AI সংকেত",

    aiInsightsDesc:
        "প্ৰাসংগিক অপাৰেশ্যনেল বুদ্ধিমত্তা, Cognitive AI, স্বয়ংক্ৰিয় এজেণ্ট, অপাৰেশ্যনেল ডায়াগনষ্টিক্স আৰু MSME ঝুঁকি সংকেত।",
  },
};

export default msmeOwnerPATranslations;